import * as types from "./types";

const initialState = {
  list: [],
  meta: {
    currentPage: 1,
    count: 0,
    pages: 1,
  },
  isLoading: false,
  creating: false,
  detail: null,
  detailLoading: false,
  updating: false,
  comments: [],
  commentsLoading: false,
  commenting: false,
};

const companyLogisticsIssues = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_LOGISTICS_ISSUES_REQUEST:
      return { ...state, isLoading: true };
    case types.GET_COMPANY_LOGISTICS_ISSUES_RESPONSE:
      return {
        ...state,
        isLoading: false,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case types.CREATE_COMPANY_LOGISTICS_ISSUE_REQUEST:
      return { ...state, creating: true };
    case types.CREATE_COMPANY_LOGISTICS_ISSUE_RESPONSE:
      return { ...state, creating: false };
    case types.GET_COMPANY_LOGISTICS_ISSUE_DETAIL_REQUEST:
      return { ...state, detailLoading: true, comments: [] };
    case types.GET_COMPANY_LOGISTICS_ISSUE_DETAIL_RESPONSE:
      return {
        ...state,
        detailLoading: false,
        detail: action.payload ?? null,
      };
    case types.UPDATE_COMPANY_LOGISTICS_ISSUE_REQUEST:
      return { ...state, updating: true };
    case types.UPDATE_COMPANY_LOGISTICS_ISSUE_RESPONSE:
      return {
        ...state,
        updating: false,
        detail: action.payload ?? state.detail,
      };
    case types.GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_REQUEST:
      return { ...state, commentsLoading: true };
    case types.GET_COMPANY_LOGISTICS_ISSUE_COMMENTS_RESPONSE:
      return {
        ...state,
        commentsLoading: false,
        comments: Array.isArray(action.payload) ? action.payload : [],
      };
    case types.CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_REQUEST:
      return { ...state, commenting: true };
    case types.CREATE_COMPANY_LOGISTICS_ISSUE_COMMENT_RESPONSE:
      return { ...state, commenting: false };
    default:
      return state;
  }
};

export default companyLogisticsIssues;
